/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 15:25 20.04.2023
 * @ Description: TestPage
 */
import React, { useState, useEffect } from 'react';
import "./index.css"
import MyButton from "../../compenent/button/MyButton";
import GamePageManager from "../../utils/GamePageManager";
import WordButton from "../../compenent/WordButton/WordButton";
import Sentence from "../../GameClass/sentence";
import SentenceError from '../../GameClass/sentenceError';
import api from '../../utils/api';

function Top10PlayerShower(props){
    return(
        <div className='Top10PlayerShower'>
            <label className='Number'>#{props.number}</label>
            <div className='Stats'>
                <label className='StatsPrime Username'>{props.username}</label>
                <label className='StatsSeconde Time'>{props.time}</label>
                <label className='StatsPrime Score'>{props.score}</label>
            </div>
        </div>
    );
}


export default function Top10() {

    const [top10Shower,setTop10Shower]=useState(null);

    useEffect(()=>{
        api.getTopTen((data)=>{
            let showers=[];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                showers.push(<Top10PlayerShower number={index+1} username={element.recName} score={element.recScore} time={new Date((element.recTime) * 1000).toISOString().slice(14, 19)}/>);
            }
            setTop10Shower(showers);
        })
    },[])


    return (
        <div className="GamePage Top10">
            <div className='Top10Title'>
                <h1>Top 10</h1>
            </div>
            <div className='Top10Shower'>
                {top10Shower}
            </div>
            <div className='BackButton'>
                <MyButton title={"Main Menu"} fontSize={40} onClick={()=>GamePageManager.changePage("MainMenu")}/>
            </div>
        </div>
    );
}

